import React from 'react';

const CameraSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 8V7h15v12H3V7h2v1h1zm3-3h6v1H9V5zM8 4v2H6V4H5v2H2v14h20V6h-6V4H8z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 18c2.8 0 5-2.2 5-5s-2.2-5-5-5-5 2.2-5 5 2.2 5 5 5m0-9c2.2 0 4 1.8 4 4s-1.8 4-4 4-4-1.8-4-4 1.8-4 4-4"
        />
    </svg>
);

CameraSvg.displayName = 'CameraSvg';
export default CameraSvg;
